import { render } from "./ButtonBox.vue?vue&type=template&id=639e47b4"
import script from "./ButtonBox.vue?vue&type=script&lang=js"
export * from "./ButtonBox.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/adriengeoorge.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__